<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Energy
                    <v-spacer></v-spacer>

                            <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <vue-plotly disable-responsive v-if="energyPieData" :data="energyPieData" :layout="energyPieLayout"
                                            :options="{}"/>
                            </v-flex>
                            <v-flex xs12 md6>
                                <vue-plotly disable-responsive v-if="energyData" :data="energyData" :layout="energyLayout" :options="{}"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <vue-plotly disable-responsive  v-if="energyCategoryData" :data="energyCategoryData" :layout="energyCategoryLayout"
                                            :options="{}"/>
                            </v-flex>
                            <v-flex xs12 md6>
                                <vue-plotly disable-responsive v-if="energyHeatmapData" :data="energyHeatmapData" :layout="energyHeatmapLayout"
                                            :options="{}"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>

    import moment from 'moment'
    import {callAPI} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import DateRangeSelector from "../components/DateRangeSelector";


    export default {
        name: 'HKLEnergy',
        components: {VuePlotly,DateRangeSelector},
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(15, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(15, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:true,
                energyData:null,
                energyPieData:null,
                energyHeatmapData:null,
                energyCategoryData:null,
                energyLayout:{
                    title:"Energy Consumption VS Baseline",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Hour'
                    }
                },
                energyCategoryLayout:{
                    title:"Energy Consumption Profile",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Time (hourly)'
                    }
                },
                energyPieLayout:{
                    title:"Energy Consumption Breakdown",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1
                    },
                },
            }
        },
        computed:{
            energyHeatmapLayout(){
                return {
                    title:"Power Heat Map",
                    yaxis: {
                        autotick: false,
                    }
                }
            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let pastRange=[moment(currentRange[0]).subtract(1, "month").startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment(currentRange[1]).subtract(1, "month").endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let promises = [
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                "equipment_type_regex": "^chiller",
                                'date_range': currentRange,
                            },
                            'etCategory': "Chillers",
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ]
                        }
                    ),
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                'equipment_type_regex': 'ecfan|ahu',
                                'date_range': currentRange,
                            },
                            'etCategory': "AHUs",
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ]
                        }
                    ),
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                "equipment_type_regex": "water_pump$",
                                'date_range': currentRange,
                            },
                            'etCategory': "Pumps",
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ]
                        }
                    ),


                ]
                let timestamp=null;
                let hours=["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];
                let currentPower={}
                let currentPowerCategTotals={};
                let currentPowerTotal=null
                Promise.all(promises).then(function (reses) {
                    for (let res of reses) {
                        if(res.data['sum']) {
                            if (!timestamp && res.data.timestamp) {
                                timestamp = res.data.timestamp;
                            }
                            let category = JSON.parse(res.config.data)["etCategory"]
                            let powerForThis = res.data['sum'].map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq)
                            if (!currentPower[category]) {
                                currentPower[category] = powerForThis
                            } else {
                                currentPower[category] = me.addArrays(currentPower[category], powerForThis)
                            }
                        }
                    }
                    let pieData={
                        type: 'pie',
                        hole: .7,
                        labels: [],
                        values: []
                    }
                    let energyCategoryData=[]
                    for (let category in currentPower){
                        if(!currentPowerTotal){
                            currentPowerTotal=currentPower[category]
                        } else {
                            currentPowerTotal=me.addArrays(currentPowerTotal,currentPower[category])
                        }
                        currentPowerCategTotals[category]=currentPower[category].reduce((sum, x) => sum + x)
                        pieData.labels.push(category)
                        pieData.values.push(currentPowerCategTotals[category])
                        energyCategoryData.push({
                            x:timestamp,
                            y:currentPower[category],
                            name:category
                        })
                    }
                    me.energyPieData=[pieData]
                    me.energyCategoryData=energyCategoryData
                    let colorscaleValue = [
                        [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                        [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
                    ]
                    let powerHObj={}
                    for (let tsindex in timestamp){
                        let cleanedts=moment(timestamp[tsindex]).startOf("day").format('YYYY-MM-DD')
                        if(!powerHObj[cleanedts]){
                            powerHObj[cleanedts]=[]
                        }
                        powerHObj[cleanedts].push(currentPowerTotal[tsindex])
                    }
                    let days=[]
                    let powerArrays=[]
                    for (let day in powerHObj){
                        days.push(day)
                        powerArrays.push(powerHObj[day])
                    }
                    me.energyHeatmapData = [{
                        x: hours,
                        y: days,
                        z: powerArrays,
                        type: 'heatmap',
                        mode: 'markers',
                        colorscale: colorscaleValue,
                    }]

                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                'date_range':pastRange,
                            },
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ]
                        }
                    ).then(function(resp){
                        if(resp.data.sum) {
                            let pastTotalPower = resp.data.sum.map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq)
                            me.energyData = [
                                {
                                    x: timestamp,
                                    y: currentPowerTotal,
                                    name: "Energy",
                                    fill: 'tozeroy',
                                    fillcolor: "rgba(31, 119, 180,0.5)",
                                    mode: "lines",
                                    line: {color: "rgba(31, 119, 180,0.5)"}
                                },
                                {
                                    x: timestamp, y: pastTotalPower,
                                    name: "Baseline (" + pastRange[0] + " - " + pastRange[1] + ")",
                                    mode: "lines",
                                    line: {color: "rgba(255, 127, 14,0.5)"}
                                },
                            ]
                        }
                        me.loading=false
                    })
                })

            }

        },
        beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.baseDate=moment(preconf.rangeStart)
                this.endDate=moment(preconf.rangeEnd)
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
            } else if(maxDate){
                this.baseDate=moment(maxDate).subtract(15, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
